import { useState, useCallback } from "react";
import * as APIModels from "../../../models";
import Select, { ActionMeta } from "react-select";

type OptionType = { label: string; value: string };

export default function PartialCaseSearch({
    sequenceDetected,
    onSearchComplete,
}: {
    sequenceDetected: string;
    onSearchComplete: (result: APIModels.CourtCase) => void;
}) {
    const [searchResults, setSearchResults] = useState(
        [] as APIModels.CourtCase[]
    );
    const [selectedCase, setSelectedCase] = useState(
        null as APIModels.CourtCase | null
    );
    const [sequenceNumber, setSequenceNumber] = useState(sequenceDetected);
    const [searching, setSearching] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const caseSearchClick = useCallback(async () => {
        setSearching(true);
    }, []);

    const onCaseChange = (
        value: OptionType | null,
        actionMeta: ActionMeta<OptionType>
    ) => {
        const matchingCases = searchResults.filter(
            (v) => v.ucn === value!.value
        );
        if (matchingCases.length > 0) {
            setSelectedCase(matchingCases[0]);
        }
    };

    const filterOption = (option: OptionType, inputValue: string): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    return (
        <>
            <div className="mb-3">
                <label htmlFor="txtSeqNum" className="form-label">
                    Sequence Number
                </label>
                <input
                    type="text"
                    className="form-control"
                    id="txtSeqNum"
                    placeholder="Sequence Number"
                    value={sequenceNumber}
                    onChange={(event) =>
                        setSequenceNumber(event.currentTarget.value)
                    }
                    required
                />
                <div className="invalid-feedback">
                    Please provide a valid sequence number.
                </div>
            </div>
            <div className="mb-3">
                <img src="/assets/images/sequence-number.png" />
            </div>
            <div className="mb-3">
                {searching ? (
                    <button
                        className="btn btn-primary"
                        type="button"
                        disabled={true}
                    >
                        <span
                            className="spinner-border spinner-border-sm me-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        Searching...
                    </button>
                ) : (
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={caseSearchClick}
                    >
                        Search
                    </button>
                )}
                <div>{errorMessage}</div>
            </div>
            {selectedCase && (
                <>
                    <div className="mb-3">
                        <label className="form-label">UCN</label>
                        <a style={{ display: "block" }}>
                            {searchResults[0].ucn}
                        </a>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Case Title</label>
                        <div>{searchResults[0].caseTitle}</div>
                    </div>
                </>
            )}
            <div className="mb-3">
                <label htmlFor="selCase" className="form-label">
                    Matching Cases
                </label>
                <Select
                    id="selCase"
                    name="selCase"
                    filterOption={filterOption}
                    options={searchResults.map((v) => {
                        return {
                            label: v.caseTitle ?? "",
                            value: v.ucn ?? "",
                        };
                    })}
                    onChange={onCaseChange}
                />
            </div>
        </>
    );
}
